// What the current organisation's plan includes. Mirrors
// billing.v_organisation_entitlement (migration 047), served read-only by
// GET /api/security/organisation/entitlements.
//
// This is for DECIDING WHAT TO RENDER, not for protecting anything — hiding a
// nav item changes nothing about what a request can reach. Enforcement lives in
// the API's requireAiFull middleware. If these ever disagree, the API wins.
export interface Entitlements {
  /** Full AI enrichment (EHCP focus areas, ABC, staff actions) + the Insights
   *  page. When false the organisation still gets Fix typos and the
   *  professional SENDCo rewrite — the same rewrite, not a lesser one. */
  aiFullEnabled: boolean;
  /** Children the plan permits. null = unbounded (the bespoke band). */
  maxChildren: number | null;
  /** true = adding a child beyond the limit is refused. false = soft cap. */
  enforceChildCap: boolean;
  tierCode: string | null;
  tierName: string | null;
  status: string | null;
}

// Used while the entitlement is loading, and if the fetch fails.
//
// FAIL CLOSED, deliberately: a premium surface must never flash into view and
// then disappear once the real answer arrives. The cost of being wrong this way
// is a moment of absence; the other way it is a feature the customer sees, tries
// and loses.
export const ENTITLEMENTS_DEFAULT: Entitlements = {
  aiFullEnabled: false,
  maxChildren: null,
  enforceChildCap: false,
  tierCode: null,
  tierName: null,
  status: null,
};
